import { AfterViewInit, Component, Injector, OnInit, ViewChild } from '@angular/core';
import { ColumnSchemaBase, ComponentContextService, DataListBase, CrudListComponent, GridInfo, ModelSchema } from 'tnx-shared';
import { ExtensionAttributeService } from 'tnx-admin-service/workflowcore/extensionattribute/services';
@Component({
    selector: 'extensionattribute',
    templateUrl: './extensionattribute.component.html',
    styleUrls: ['./extensionattribute.component.scss'],
    providers: [ComponentContextService],
})
export class ExtensionAttributeComponent extends DataListBase implements OnInit, AfterViewInit {
    searchSchema: any = {};
    searchData: any = {};
    constructor(
        protected _injector: Injector,
        protected _extensionAttributeService: ExtensionAttributeService,
    ) {
        super(_injector);
    }

    ngOnInit() {
        this.setting.baseService = this._extensionAttributeService;
        this.setting.modelSchemas = [
            new ModelSchema({ field: 'persistenceId', dataType: 'int', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'attributeKey', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'attributeValue', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'executionPointerId', dataType: 'int', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'currentStateCode', name: '', fullName: '', description: '' }),
            new ModelSchema({ field: 'code', name: '', fullName: '', description: '' })
        ];

        this.setting.cols = [
            new ColumnSchemaBase({ field: 'persistenceId' }),
            new ColumnSchemaBase({ field: 'attributeKey' }),
            new ColumnSchemaBase({ field: 'attributeValue' }),
            new ColumnSchemaBase({ field: 'executionPointerId' }),
            new ColumnSchemaBase({ field: 'currentStateCode' }),
            new ColumnSchemaBase({ field: 'code' })
        ];

        super.ngOnInit();
    }
}

